import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  setItem(key: string, value: any): void {
    try {
      const jsonString = JSON.stringify(value);
      const base64String = btoa(encodeURIComponent(jsonString));
      sessionStorage.setItem(key, base64String);
    } catch (e) {
      console.error('Error saving to sessionStorage', e);
    }
  }

  getItem(key: string): any {
    try {
      const base64String = sessionStorage.getItem(key);
      if (base64String) {
        const jsonString = decodeURIComponent(atob(base64String));
        return JSON.parse(jsonString);
      }
      return null;
    } catch (e) {
      console.error('Error getting data from sessionStorage', e);
      return null;
    }
  }

  removeItem(key: string): void {
    sessionStorage.removeItem(key);
  }

  clear(): void {
    sessionStorage.clear();
  }
}
